export default {
    companyHoliday: 'Company Holiday',
    searchByHolidayName: 'Search by Holiday Name',
    search: 'Search',
    createNewHoliday: 'Create New Holiday',
    holidayName: 'Holiday Name',
    holidayDate: 'Holiday Date',
    dateCreate: 'Date Create',
    description: 'Description',
    companyHolidayIsDeleted: 'Company Holiday is deleted',
    congratulation: 'Congratulation',
    deleteCompanyHoliday: 'Delete Company Holiday',
    wantToDelete: 'Are you sure you want to delete'
}
